var _rect, _rect2, _text, _text2, _style;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProductBuilderTemplatePhoneCase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1502,
    height: 2304,
    fill: "none",
    viewBox: "0 0 1502 2304",
    role: "img",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    vectorEffect: "non-scaling-stroke",
    strokeWidth: 1,
    width: 1104.65,
    height: 2160.92,
    x: 199.36,
    y: 74.26,
    stroke: "#0080FF",
    rx: 40
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    vectorEffect: "non-scaling-stroke",
    strokeWidth: 1,
    width: 761.25,
    height: 1088,
    x: 370.02,
    y: 950,
    stroke: "red",
    rx: 40
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 650,
    y: 140,
    className: "blue"
  }, "Print area")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 650,
    y: 1015
  }, "Safe area")), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    text {\n      font-family:sans-serif;\n      fill: red;\n      font-size: 50px;\n      paint-order: stroke;\n      stroke: #fff;\n      stroke-width: 20px;\n      stroke-linecap: butt;\n      stroke-linejoin: round;\n      opacity: .66;\n      text-align: center;\n    }\n    .blue {\n      fill: #0080FF;\n    }\n  ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductBuilderTemplatePhoneCase);
export default __webpack_public_path__ + "static/media/product-builder-template_phone-case.e94f3375013b53148590c8150042e80f.svg";
export { ForwardRef as ReactComponent };